/* eslint-disable indent */
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import vuetify from '@/plugins/vuetify'
import MockAuthenticator from './services/authenticatorMock'
import RouteLeafAuthenticator from './services/authenticatorRouteLeaf'
import App from './pages/App'
import router from './router'
import createStore from './store'
import ClientAuthSupport from './store/auth'
import StarHouseDataStore from './store/starhouse'
import './registerServiceWorker'
import appInject from './app-inject'

const isProd = (process.env.NODE_ENV === 'production')
Vue.config.devtools = !isProd
Vue.config.productionTip = !isProd

const appVersion = process.env.VUE_APP_VERSION

// Initialize vuex store
const store = createStore() // create the base app store (app, user)

// Sync router with the store
sync(store, router)

// Set application meta
store.dispatch('app/setPlatform', 'RouteLeaf')
store.dispatch('app/setName', 'Web UI')
store.dispatch('app/setAlias', 'web-ui')
store.dispatch('app/setVersion', appVersion)

// Instantiate authenticator (for Auth Provider)
const useMockAuth = (process.env.VUE_APP_AUTH_PROVIDER === 'mock')
const Authenticator = (useMockAuth)
  ? new MockAuthenticator({
      ttl: process.env.VUE_APP_AUTH_MOCK_TOKEN_TTL || 60 * 60 * 1000
    })
  : new RouteLeafAuthenticator({
      debug: false,
      region: process.env.VUE_APP_AUTH_COGNITO_REGION,
      userPoolId: process.env.VUE_APP_AUTH_COGNITO_USER_POOL_ID,
      webClientId: process.env.VUE_APP_AUTH_COGNITO_WEB_CLIENT_ID,
      oauth: {
        domain: process.env.VUE_APP_AUTH_OAUTH_DOMAIN,
        scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: process.env.VUE_APP_AUTH_OAUTH_REDIRECT_LOGIN,
        redirectSignOut: process.env.VUE_APP_AUTH_OAUTH_REDIRECT_LOGOUT,
        responseType: 'code' // code|token
      }
    })

// Bootstrap with client auth support
Vue.use(ClientAuthSupport, {
  logInit: true,
  debug: false,
  store,
  router,
  authenticator: Authenticator,
  includeUserInfo: true,
  directUnAuthedTo: 'login'
})

// Bootstrap with starhouse data store
Vue.use(StarHouseDataStore, {
  logInit: true,
  store
})

new Vue({
  router, // inject router => reference as: this.$router
  store, // inject store => reference as: this.$store
  ...appInject, // inject global data and functions
  vuetify,
  render: h => h(App) // load app components (Pages and Components)
}).$mount('#app')
